module.exports = __webpack_public_path__ + "static/illustration-ecosystem-l1-50a92b67c033912be463075b605ae342.webp";